let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8TBzz")).then(() => parcelRequire('jAOOx'));